import React from 'react';
import styled from 'styled-components';
import Rating from 'sushiweb/Rating';

const RatingWrapper = styled(Rating)`
   {
    font-weight: 500;
    border-radius: 6px;
    margin: 0px 8px;
  }
`;

export const RatingBox = ({
  title = '',
  bgColor = 'green',
  tagWidth = 'inherit',
}) => {
  let RatingTemplate = (
    <div>
      <RatingWrapper value={title} size='1.4rem' color={bgColor} />
    </div>
  );
  return RatingTemplate;
};
